export default __webpack_public_path__ + "static/media/Teo.28e5c8f2.jpg";